import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import Ajax from "Pub/js/ajax";
import Notice from "Components/Notice";
import Appicon from "Components/Appicon";
import { withRouter } from "react-router-dom";
import PreviewModal from "Components/TempletPreview";
import { GetQuery, langCheck, isInsideTab } from "Pub/js/utils";
import { openPage } from "Pub/js/superJump";
import { APP_INFO } from "Pub/js/constant";
import withVaryModal from "Components/withVaryModal";
import HotKeysModal from "Components/HotKeysModal";
import { setZoneData } from "Store/Zone/action";
import {
    updateSelectArea,
    updateAreaList,
    updateSaveFlag,
    setZoneDataFun,
    updateAreaValidate,
    setAreaItemVisible,
    setServerData,
    setAreaHide,
    setTabLayModalVisible,
    updateSelectCard,
} from "Store/ZoneSetting/action";
import {
    queryAllArea,
    queryTemplateProperty,
    findRepeatItemsByCode,
    setActiveTabKey,
    pubSubAction,
} from "./events";
import _ from "lodash";
import platform from "Pub/js/platform";
import SearchBox from "./components/SearchBox/WithTemplateArea";
const { metaCache, pageTo, PubSub } = platform;
let { getMetaCache, removeMetaCache } = metaCache;
const { NCDiv, NCButton, NCDropdown, NCMenu, NCCheckbox, NCTooltip } = platform.base;
const { Item, NCSubMenu } = NCMenu;
import { getMultiLangText } from './utilService';

class MyHeader extends Component {
    constructor(props) {
        super(props);
        this.urlRequestObj = GetQuery(this.props.location.search);
        this.state = {
            previewVisibel: false,
            backModalShow: false,
            areaItemVisible: {},
            isSaveBtnLoading: false, //保存按钮loading标记 防止重复点击保存
        };
        //本文件sonar扫描箭头函数不能解析，为了让sonar扫描通过，只能先这么写
        this.handleBindKey = this.handleBindKey.bind(this);
        this.setPreviewModalVisibel = this.setPreviewModalVisibel.bind(this);
        this.validateEmptyArea = this.validateEmptyArea.bind(this);
        this.validateCode = this.validateCode.bind(this);
        this.setAreaListValidate = this.setAreaListValidate.bind(this);
        this.saveTemplate = this.saveTemplate.bind(this);
        this.saveZoneData = this.saveZoneData.bind(this);
        this.saveData = this.saveData.bind(this);
        this.toggleBackModal = this.toggleBackModal.bind(this);
        this.handleBack = this.handleBack.bind(this);
        this.setDefault = this.setDefault.bind(this);
        this.back = this.back.bind(this);
        this.handleSaveBack = this.handleSaveBack.bind(this);
        this.handleNotSaveBack = this.handleNotSaveBack.bind(this);
        this.handleCancelBack = this.handleCancelBack.bind(this);
        this.handleTabSettingModal = this.handleTabSettingModal.bind(this);
        this.getPreviewData = this.getPreviewData.bind(this);
        this.showTabLayoutBtn = this.showTabLayoutBtn.bind(this);
        this.getAreaHideproperty = this.getAreaHideproperty.bind(this);
    }
    componentDidMount() {
        document.addEventListener("keydown", this.handleBindKey, false);
    }
    componentWillUnmount() {
        document.removeEventListener("keydown", this.handleBindKey, false);
    }
    // 模板快捷键返回
    handleBindKey(event) {
        if (this.isHideBack()) { return; }
        let e = event || window.event || arguments.callee.caller.arguments[0];
        if (e && e.keyCode) {
            if (e.shiftKey && e.keyCode == 27) {
                this.handleBack();
            }
        }
    }
    //预览模态框是否显示
    setPreviewModalVisibel(visibel) {
        this.setState({ previewVisibel: visibel });
    }
    //删除左右两端的空格
    trim(str) {
        if (typeof str === 'string') {
            return str.trim();
        }
    }

    //校验区域编码、名称为空
    validateEmptyArea() {
        const { json, areaList, newAreaList } = this.props;
        let newList = _.cloneDeep(areaList);
        let result = true;
        const areaCodeLang = langCheck("102202APP-000038", "pages", json); /* 国际化处理： 区域编码*/
        const areaNameLang = langCheck("102202APP-000039", "pages", json); /* 国际化处理： 区域名称*/
        let emptyMsg = [];
        let emptyArea = areaList.filter(area => !area.code || !area.name);
        const simpleArea = newAreaList.filter(r => r !== null);
        if (emptyArea && emptyArea.length > 0) {
            simpleArea.forEach((area, index) => {
                if (!area.code || !area.name) {
                    const prefix = langCheck("ZoneSetting-000046", "pages", json); /* 国际化处理： 区域*/
                    const msg = getEmptyMsg(area, `${prefix}${index + 1}`);
                    emptyMsg.push(msg);
                }
                if (simpleArea.length !== newAreaList.length) {
                    validateEmptySpecialArea(area);
                }
            });
            result = false;
        }

        if (!result) {
            Notice({
                status: "error",
                TextArr: [
                    langCheck("ZoneSetting-000012", "pages", json) /* 国际化处理： 展开*/,
                    langCheck("ZoneSetting-000011", "pages", json) /* 国际化处理： 收起*/,
                    langCheck("ZoneSetting-000224", "pages", json), /* 国际化处理： 关闭*/
                ],
                content: langCheck("102202APP-000012", "pages", json) /* 国际化处理： 区域编码或名称不能为空*/,
                groupOperation: true,
                groupOperationMsg: emptyMsg,
            });
            this.setAreaListValidate(newList, emptyArea);
            this.props.updateAreaList(newList);
            // 隐藏区域使用
            // this.props.isImplement && this.props.setServerData(newList)
            this.props.updateAreaValidate(result);
        }
        return result;

        //校验分组、侧拉、孙表区域编码/名称为空
        function validateEmptySpecialArea(area) {
            const msgObj = {
                groups: langCheck("ZoneSetting-000208", "pages", json) /* 国际化处理： 分组*/,
                sides: {
                    edit: langCheck("ZoneSetting-000222", "pages", json) /* 国际化处理： 侧拉*/,
                    browse: langCheck("ZoneSetting-000215", "pages", json), /* 国际化处理： 展开卡片*/
                },
                grandsons: langCheck("ZoneSetting-000223", "pages", json), /* 国际化处理： 孙表*/
            };
            for (const [key, stype] of Object.entries(msgObj)) {
                const areaIndex = simpleArea.findIndex(item => item.pk_area === area.pk_area) + 1; //最外层区域序号
                const areaStr = langCheck("ZoneSetting-000046", "pages", json); /* 国际化处理： 区域*/
                if (key in area) {
                    area[key].forEach((item, index, sArr) => {
                        if (!item.code || !item.name) {
                            let suffix = key === "sides" ? `${stype[item.areastatus]}` : `${stype}${index + 1}`;
                            const msgPrefix = `${areaStr}${areaIndex}-${suffix}`;
                            const msg = getEmptyMsg(item, msgPrefix);
                            emptyMsg.push(msg);
                            result = false;
                        }
                    });
                }
            }
        }

        function getEmptyMsg(area, prefix) {
            let msg = "";
            if (!area.code && !area.name) {
                //区域编码、名称都为空
                msg = `${prefix}：${[areaCodeLang, areaNameLang].join()}`;
            } else if (!area.code) {
                //区域编码为空
                msg = `${prefix}：${areaCodeLang}`;
            } else if (!area.name) {
                //区域名称为空
                msg = `${prefix}：${areaNameLang}`;
            }
            return msg;
        }
    }

    // 校验tableCode
    validateCode(list) {
        const { json } = this.props;
        let newList = _.cloneDeep(list);
        let result = true;
        let repeatArea = findRepeatItemsByCode(list);
        let isAreaEmpty = this.validateEmptyArea();
        //校验为空
        if (isAreaEmpty === false) {
            return isAreaEmpty;
        }
        // 校验code重复
        if (repeatArea && repeatArea.length > 0) {
            let repeatNames = repeatArea.map(item => item.name);
            Notice({
                status: "error",
                msg: `${langCheck("ZoneSetting-000046", "pages", json)}${JSON.stringify(repeatNames)}${langCheck(
                    "102202APP-000011",
                    "pages",
                    json,
                )}`,
            }); /* 国际化处理： 编码不能重复*/
            result = false;
            this.setAreaListValidate(newList, repeatArea);
            this.props.updateAreaList(newList);
            this.props.updateAreaValidate(result);
        }

        return result;
    }
    //设置未校验通过标示
    setAreaListValidate(newList, areas) {
        newList.forEach((area, index) => {
            area.validate = true;
            areas.forEach(item => {
                if (area.pk_area === item.pk_area) {
                    newList[index].validate = false;
                }
            });
        });
    }
    //先保存区域数据 成功之后回调保存字段接口
    saveTemplate(refresh = true) {
        return new Promise(resolve => {
            this.saveZoneData(refresh).then(data => {
                this.saveData({
                    newAreaData: data && data.area, //保存新增的区域
                    newTempletid: data.templetid,
                    refresh,
                }).then(resolve);
                //设置默认模板
                if (this.props.zoneFormData.isdefault) {
                    this.setDefault(data && data.templetid);
                }
            });
        });
    }

    validateTableAreasPageSize() {
        let { areaList, newAreaList, json } = this.props;
        let newList = newAreaList.filter(r => r !== null && r.type === '2');
        let noPageSizeList = [];
        let beyondPageSizeList = [];
        let noIntegerList = [];
        let noPageSizeMsg = '';
        let beyondPageSizeMsg = '';
        let ret = false;
        newAreaList.forEach(area => {
            if (!area) { return; }
            let { areatype, pagesize, code } = area;
            if (area && areatype === '2') {
                if (!pagesize) {
                    noPageSizeList.push(code);
                }
                pagesize = parseFloat(pagesize);
                if (!_.isInteger(pagesize)) {
                    noIntegerList.push(code);
                } else if (pagesize > 5000 || pagesize < 1) {
                    beyondPageSizeList.push(code);
                }
            }
            return null;
        });
        ret = noPageSizeList.length === 0 &&
            beyondPageSizeList.length === 0 &&
            noIntegerList.length === 0;
        if (!ret) {
            if (noPageSizeList.length > 0) {
                noPageSizeMsg = `${noPageSizeList.join(', ')}${langCheck('ZoneSetting-000353', 'pages', json)}\n`;
            }
            if (beyondPageSizeList.length > 0 || noIntegerList.length > 0) {
                beyondPageSizeList = `${beyondPageSizeList.concat(noIntegerList).join(', ')}${langCheck('ZoneSetting-000354', 'pages', json)}`;
            }
            Notice({
                status: "warning",
                msg: `${noPageSizeMsg}${beyondPageSizeList}`,
            });
        }
        return ret;
    }

    //保存区域
    saveZoneData(refresh) {
        return new Promise((resolve, reject) => {
            let { json, areaList, zoneDatas } = this.props;
            let param = GetQuery(this.props.location.search);
            let url, datas;
            url = "/nccloud/platform/templet/settempletarea.do";
            let fromData = this.props.zoneFormData;
            if (!this.verifyAreaProperty()) { return; }
            //校验表头
            if (areaList.some(item => item.areatype !== "0") && !fromData.headcode) {
                Notice({
                    status: "warning",
                    msg: langCheck("102202APP-000073", "pages", json),
                }); /* 国际化处理： 请选择表头*/
                return;
            }
            // 检验 表单的合法性
            if (!fromData || !fromData.code || !this.trim(fromData.code) || !this.trim(fromData.name)) {
                Notice({
                    status: "warning",
                    msg: langCheck("102202APP-000063", "pages", json),
                }); /* 国际化处理： 请完善表单信息*/
                return;
            }
            if (!areaList || areaList.length <= 0) {
                Notice({
                    status: "warning",
                    msg: langCheck("102202APP-000019", "pages", json),
                }); /* 国际化处理： 请完善表格和表单信息*/
                return;
            }
            //  校验 表格的合法性
            let validateResult = this.validateCode(areaList);
            let validatePageSize = this.validateTableAreasPageSize();
            let newList = _.cloneDeep(areaList);
            newList.map((item, index) => {
                if (item.newArea) {
                    item.pk_area && delete item.pk_area;
                }
                item.formPropertyList = [];
                item.queryPropertyList = [];
                item.position = index + 1 + ""; //区域排序
            });
            datas = {
                pk_page_templet: zoneDatas.pk_page_templet,
                pagecode: zoneDatas.pagecode || param.pcode,
                pageid: zoneDatas.pageid || param.pid,
                parentid: zoneDatas.parentid || "root",
                areaList: newList,
                isdefault: fromData.isdefault,
                appcode: param.tplappcode || param.appcode || zoneDatas.appcode,
                mateid: zoneDatas.mateid,
                ts: this.ts || this.props.ts,
            };
            datas = Object.assign(fromData, datas);
            if (validateResult && validatePageSize) {
                Ajax({
                    url: url,
                    data: datas,
                    info: {
                        name: langCheck("102202APP-000013", "pages", json) /* 国际化处理： 保存区域*/,
                        action: langCheck("102202APP-000014", "pages", json), /* 国际化处理： 保存区域设置*/
                    },
                    success: ({ data }) => {
                        if (data.success && data.data) {
                            if (!data.data.templetid) {
                                Notice({ status: "error", msg: data.data.msg });
                            }
                            // this.props.setZoneData({});
                            if (refresh) { queryAllArea.call(this, data.data.templetid); }
                            resolve(data.data);
                        }
                    },
                    error: error => {
                        reject();
                        console.log(error.data);
                    },
                });
            }
        });
    }

    // 校验区域属性
    verifyAreaProperty() {
        let configRefer = true;
        const { areaList, json } = this.props;
        // 配置参照,参照名称不能为空
        _.forEach(areaList, (al, idx) => {
            if (al.areatype === "0") {
                //只对参照类型做判断
                _.forEach(al.queryPropertyList, (daty, kk) => {
                    if (
                        daty.datatype === "204" &&
                        (daty.refname === "-99" ||
                            daty.refname === "" ||
                            daty.refname === null ||
                            daty.refname === undefined)
                    ) {
                        Notice({
                            status: "typeError",
                            /* 国际化处理： 区域,下的,的,参照名称,字段属性未正确设置,请检查配置*/
                            msg: langCheck('ZoneSetting-000047', 'pages', json, [al.name, daty.label]),
                        });
                        configRefer = false;
                    }
                });
            }
            //非查询区占用列数不能为负数
            if (al.areatype == "1") {
                _.forEach(al.queryPropertyList, (colvalue, key) => {
                    if (colvalue.colnum < 0) {
                        //占用列数属性字段不能为负数
                        Notice({
                            status: "typeError",
                            /* 国际化处理： 区域,下的,的,占用列数,字段属性不能为负数,请检查配置*/
                            msg: langCheck('ZoneSetting-000048', 'pages', json, [al.name, colvalue.label]),
                        });
                        configRefer = false;
                    }
                    // 移动附件校验
                    if (this.props.ismobile && colvalue.datatype === "300") {
                        // if (colvalue.itemtype === "photo") {
                        //     if (!_.isInteger(+colvalue.uploadquantity)) {
                        //         Notice({
                        //             status: "typeError",
                        //             msg: `${langCheck(
                        //                 "ZoneSetting-000320",
                        //                 "pages",
                        //                 json
                        //             )} ` /* 国际化处理： 上传张数必须为整数*/
                        //         });
                        //         configRefer = false;
                        //     } else if (_.isInteger(+colvalue.uploadquantity) && +colvalue.uploadquantity < 1) {
                        //         Notice({
                        //             status: "typeError",
                        //             msg: `${langCheck(
                        //                 "ZoneSetting-000321",
                        //                 "pages",
                        //                 json
                        //             )} ` /* 国际化处理： 上传张数不能小于1*/
                        //         });
                        //         configRefer = false;
                        //     }
                        //     if (colvalue.uploadquantity != "") {
                        //         colvalue.uploadquantity = +colvalue.uploadquantity;
                        //     }
                        // } else if (colvalue.itemtype === "attachment") {
                        //     if (
                        //         colvalue.uploadquantity !== "" &&
                        //         (_.isNaN(+colvalue.uploadquantity) || !_.isInteger(+colvalue.uploadquantity))
                        //     ) {
                        //         Notice({
                        //             status: "typeError",
                        //             msg: `${langCheck(
                        //                 "ZoneSetting-000320",
                        //                 "pages",
                        //                 json
                        //             )} ` /* 国际化处理： 上传张数必须为整数*/
                        //         });
                        //         configRefer = false;
                        //     }
                        // }
                        // 透明度做/100转化
                        if (colvalue.watermarktype === 1) {
                            if (_.isNumber(colvalue.watermarkalpha)) {
                                colvalue.watermarkalpha = colvalue.watermarkalpha / 100;
                            }
                        }
                    }
                });
            }
        });

        return configRefer;
    }

    //保存字段 newAreaData：新增的区域数据 refresh：保存后是否查询
    saveData({ newAreaData, refresh, newTempletid } = {}) {
        return new Promise(resolve => {
            const { areaList, pcode, appcode, json } = this.props;
            const templetid = this.props.templetid || newTempletid;
            let formPropertyList = [];
            let queryPropertyList = [];
            //将pk_query_property置为空；
            _.forEach(areaList, (a, index) => {
                _.forEach(a.queryPropertyList, q => {
                    if (q.pk_query_property && q.pk_query_property.indexOf("new") !== -1) {
                        // q.pk_query_property = "";
                        delete q.pk_query_property;
                    }
                });
            });
            //将queryPropertyList按照区域的类型进行form和query分类
            _.forEach(areaList, (a, index) => {
                if (a.newArea) {
                    const newAreaId = newAreaData && newAreaData.find(item => item.code === a.code);
                    //将新增的区域id与字段所属区域对应上
                    a.queryPropertyList.map(item => {
                        item.areaid = newAreaId && newAreaId.pk_area;
                    });
                }
                if (a.areatype === "0") {
                    queryPropertyList = queryPropertyList.concat(a.queryPropertyList);
                } else {
                    formPropertyList = formPropertyList.concat(a.queryPropertyList);
                }
            });

            const saveData = {};
            saveData.templetid = templetid;
            saveData.formPropertyList = formPropertyList;
            saveData.queryPropertyList = queryPropertyList;
            saveData.ismobile = this.props.ismobile; //是否为移动模板
            saveData.varyId = this.state.varyId; //变更号
            this.setState({ isSaveBtnLoading: true }); //控制保存按钮loading状态
            //保存请求
            Ajax({
                url: `/nccloud/platform/templet/setareaproperty.do`,
                info: {
                    name: langCheck("ZoneSetting-000017", "pages", json) /* 国际化处理： 单据模板设置*/,
                    action: langCheck("ZoneSetting-000033", "pages", json), /* 国际化处理： 保存区域与属性*/
                },
                data: saveData,
                loading: true, //发送保存请求时页面显示loading
                success: res => {
                    // let param = GetQuery(this.props.location.search);
                    const { data, success } = res.data;
                    if (success) {
                        Notice({ status: "success", msg: data.msg });
                        //保存成功后需要清除localstorage本地缓存appcode_pcode
                        if (getMetaCache(appcode, pcode)) {
                            removeMetaCache(appcode, pcode);
                        }
                        //修改模板保存重新查字段
                        if (refresh) {
                            queryTemplateProperty.call(this, templetid);
                        }
                        PubSub.publish(pubSubAction.isSave); //更新模板保存标示
                        this.props.updateSelectCard({}); //保存后清空选中字段
                        this.setState({ isSaveBtnLoading: false }); //去掉保存按钮loading
                        this.ts = data.ts;
                        // this.props.isImplement && this.props.setServerData(areaList)
                        resolve();
                    } else {
                        Notice({ status: "error", msg: data });
                    }
                },
                error: () => {
                    this.setState({ isSaveBtnLoading: false }); //去掉保存按钮loading
                },
            });
        });
    }

    toggleBackModal(flag) {
        this.setState({ backModalShow: flag });
    }

    //点击返回
    handleBack() {
        //保存过不显示返回弹框
        if (this.props.isSave) {
            this.handleNotSaveBack();
        } else {
            this.toggleBackModal(true);
        }
    }

    /**
     * 设置默认模板
     */
    setDefault(pk_page_templet) {
        Ajax({
            url: `/nccloud/platform/templet/setdefaulttemplet.do`,
            info: {
                name: langCheck(
                    "102202APP-000074",
                    "pages",
                    this.props.langJson,
                ) /* 国际化处理： 应用注册*/,
                action: langCheck(
                    "102202APP-000117",
                    "pages",
                    this.props.langJson,
                ), /* 国际化处理： 设置默认模板*/
            },
            data: {
                pagecode: this.props.zoneDatas.pagecode,
                appcode: this.props.zoneDatas.appcode,
                templetid: pk_page_templet,
            },
            success: () => { },
        });
    }
    //返回跳转
    back() {
        // const { status } = this.props;
        // const { AppRegister, TemplateSetting } = APP_INFO;
        // if (status) {
        //     // 实施态
        //     if (status === "templateSetting") {
        //         //移动模板设置
        //         if(this.urlRequestObj.templettype !== "mobile") {
        //             pageTo.linkTo(TemplateSetting.url, {
        //                 appcode: TemplateSetting.appcode,
        //                 pagecode: TemplateSetting.pagecode,
        //                 selectedKey: this.urlRequestObj.selectedKey
        //             });
        //         }
        //     } else if (status === "templateSetting-unit") {
        //         // openPage(`/TemplateSetting-unit`, false, {}, ["status", "templetid"]);
        //     }
        // } else {
        //     if (this.urlRequestObj.templettype !== "mobile") {
        //         //应用注册
        //         pageTo.openTo(AppRegister.url, {
        //             appcode: AppRegister.appcode,
        //             pagecode: AppRegister.pagecode,
        //             selectedkey: this.urlRequestObj.pk_apppage
        //         });
        //     } 
        // }
        if (isInsideTab()) {
            this.props.history.push(`/`);
        } else {
            if (window.history.length === 1) { // 没有历史记录，返回不了，直接关掉
                self.opener = null;
                self.close();
                return;
            }
            window.history.go(-1);
        }
    }

    //保存并返回
    handleSaveBack() {
        this.saveTemplate(false).then(this.back);
        this.toggleBackModal(false);
    }

    //不保存并返回
    handleNotSaveBack() {
        this.back();
    }

    //取消返回
    handleCancelBack() {
        this.toggleBackModal(false);
    }

    //页面布局设置
    handleTabSettingModal() {
        this.props.setTabLayModalVisible(true);
    }

    //得到预览数据
    getPreviewData() {
        let areaList = _.cloneDeep(this.props.areaList);
        areaList.forEach(item => {
            item.formPropertyList = [...item.queryPropertyList];
            //字段position改成字符串
            item.formPropertyList.forEach(j => {
                j.position = j.position && j.position + "";
            });
            item.queryPropertyList.forEach(j => {
                j.position = j.position && j.position + "";
            });
        });
        return areaList;
    }

    // 计算全部

    countAllChecked(arr = [], obj = {}) {
        let flag = true;
        arr.forEach(item => {
            if (!obj[item.pk_area]) {
                flag = false;
            }
        });
        return flag;
    }

    //判断显示页签布局设置按钮
    showTabLayoutBtn() {
        const { newAreaList } = this.props;
        const formTabArea = newAreaList.find(item => item && item.areatype === '1' && item.formTabs);
        const isFormTab = formTabArea && formTabArea.formTabs.length > 1; //主表至少有2个页签
        return newAreaList.filter(item => item && (item.tabs || item.tabheadcode || isFormTab || item.grandsons)).length > 0;
    }

    // 获取 隐藏不可见区域  处理区域的
    getAreaHideproperty() {
        // let newAreaList = _.cloneDeep(this.props.newAreaList);
        // let { areaList } = this.props;
        // newAreaList
        //     .filter(item => item)
        //     .map(item => {
        //             newOrderList.push(item);
        //             if (item.sides) {
        //                     let side = item.sides.find(e => e.areastatus === "browse");
        //                     if (side) newOrderList.push(side);
        //                     let fold = item.sides.find(e => e.areastatus === "edit");
        //                     if (fold) newOrderList.push(fold);
        //                 }
        //             });
        let { areaVisible, json, areaHide, multiOptions } = this.props;
        let newOrderList = _.cloneDeep(this.props.areaList);
        let newList = newOrderList.filter(item => item.areahide);
        let pkList = newOrderList.map(item => item.pk_area);
        let areaPkList = newList.map(item => item.pk_area);
        let temp = {};
        let areaTemp = {};
        return (
            <NCMenu
                className="areahide-menu"
                onSelect={(a, b, c) => {
                    console.log(a, b, c);
                }}
                selectable={false}
                style={{ width: "150px" }}
                mode='vertical'>
                <NCSubMenu
                    key='hide-item'
                    title={langCheck("ZoneSetting-000248", "pages", json)}
                    popupClassName='test-hide-item'
                // className="hide-item-"
                >
                    <Item key='hide-item-all'>
                        <NCCheckbox
                            onChange={val => {
                                pkList.forEach(item => (temp[item] = val));
                                this.props.setAreaItemVisible(temp);
                            }}
                            checked={this.countAllChecked(newOrderList, areaVisible)}
                        >
                            {langCheck("ZoneSetting-000250", "pages", json)}
                            {/* /* 国际化处理： 全部*/}
                        </NCCheckbox>
                    </Item>
                    {newOrderList.map(item => {
                        return (
                            <Item key={item.pk_area}>
                                <NCCheckbox
                                    checked={areaVisible[item.pk_area] || false}
                                    onChange={val => {
                                        this.props.setAreaItemVisible({
                                            ...this.props.areaVisible,
                                            [item.pk_area]: val,
                                        });
                                    }}
                                >
                                    {getMultiLangText(item, 'name', multiOptions)}
                                </NCCheckbox>
                            </Item>
                        );
                    })}
                </NCSubMenu>
                <NCSubMenu
                    key='hide-area'
                    title={langCheck("ZoneSetting-000249", "pages", json)}
                    disabled={newList.length ? false : true}
                    popupClassName='test-hide-item'>
                    <Item key='hide-area-all'>
                        <NCCheckbox
                            onChange={val => {
                                areaPkList.forEach(item => (areaTemp[item] = val));
                                this.props.setAreaHide(areaTemp);
                                val && this.props.updateSelectArea({});
                            }}
                            checked={this.countAllChecked(newList, areaHide)}
                        >
                            {langCheck("ZoneSetting-000250", "pages", json)}
                            {/* /* 国际化处理： 全部*/}
                        </NCCheckbox>
                    </Item>
                    {newList.map((item, index) => {
                        return (
                            <Item key={item.code}>
                                <NCCheckbox
                                    checked={areaHide[item.pk_area] || false}
                                    onChange={val => {
                                        this.props.setAreaHide({ ...this.props.areaHide, [item.pk_area]: val });
                                        //隐藏多页签区域时选中对应子表第一个页签
                                        if (item.associatedtab) {
                                            setActiveTabKey({
                                                activeKey: item.associatedtab,
                                                areaCode: item.associatedtab,
                                            });
                                        }
                                        // 隐藏侧拉
                                        if (val && item.areastatus == "edit" && item.areatype == "1") {
                                            let $side = document.querySelector(
                                                `.search-area-${String(item.code).replace(/\.|\&|\#/g, "") || "unknow"}`,
                                            );
                                            let $closeBtn = $side && $side.querySelector(".drawer-close-btn");

                                            $closeBtn && $closeBtn.click();
                                        }
                                        // 卡片隐藏
                                        // if(val && item.areastatus == 'browse' && item.areatype == '1'){

                                        //     // let currentList = newList.find(cur => cur.sides && cur.sides.find(i => i.pk_area == item.pk_area))
                                        //     // let $side = document.querySelector(`.search-area-${currentList.code}`);
                                        //     // $side && $side.click();

                                        // }
                                        val && this.props.updateSelectArea({});
                                    }}
                                >
                                    {item.name}
                                </NCCheckbox>
                            </Item>
                        );
                    })}
                </NCSubMenu>
            </NCMenu>
        );
    }
    isHideBack = () => {
        const { hideback } = GetQuery(window.location.hash);
        return hideback || this.props.hideBackBtn;
    }
    render() {
        let { previewVisibel } = this.state;
        let { json, zoneDatas, newAreaList, areaHide, areaVisible } = this.props;
        const { c } = GetQuery(window.location.hash);
        const templetData = {
            pagecode: zoneDatas.pagecode,
            appcode: zoneDatas.appcode,
            templetid: this.props.templetid,
        };
        return (
            <Fragment>
                <NCDiv className='template-setting-header' areaCode={NCDiv.config.HEADER}>
                    <div className='setting-header-left'>
                        <div className='header-name'>
                            {/* 增加参数控制返回按钮的显示 */}
                            {!this.isHideBack() && <i className='iconfont icon-danjufanhuiicon' onClick={this.handleBack} />}
                            <Appicon appCode={c} />
                            <NCDiv fieldid={langCheck("ZoneSetting-000035", "pages", json)} areaCode={NCDiv.config.Title}>
                                {/* /* 国际化处理： 配置模板区域*/}
                                {langCheck("ZoneSetting-000035", "pages", json)}
                            </NCDiv>
                        </div>
                        {/* 加ts 保证 每次header更新  searchbox 都能进 ReceiveProps */}
                        <SearchBox
                            sourceData={newAreaList}
                            ts={new Date().getTime()}
                            areaHide={areaHide}
                            areaVisible={areaVisible}
                            json={json}
                            multiOptions={this.props.multiOptions}
                        />
                    </div>
                    <div className='button-list'>
                        <NCButton
                            colors="primary"
                            fieldid="save"
                            loading={this.state.isSaveBtnLoading}
                            onClick={() => this.props.showVaryModal()}
                        >
                            {langCheck("ZoneSetting-000038", "pages", json)}
                            {/* /* 国际化处理： 保存*/}
                        </NCButton>
                        {this.props.isImplement ? (
                            <NCDropdown
                                trigger={["click"]}
                                overlay={this.getAreaHideproperty()}
                                animation='slide-up'
                                overlayClassName='drop-more'>
                                <NCButton fieldid='hide'>
                                    {langCheck("ZoneSetting-000252", "pages", json)}
                                    {/* /* 国际化处理： 隐藏*/}
                                </NCButton>
                            </NCDropdown>
                        ) : null}
                        {
                            this.showTabLayoutBtn() && (
                                <NCButton
                                    fieldid="tabSetting"
                                    onClick={this.handleTabSettingModal}
                                >
                                    {langCheck('ZoneSetting-000259', 'pages', json)}
                                </NCButton>
                            )
                        }

                        {/*  国际化处理： 页签布局设置  */}
                        <NCTooltip
                            // "ZoneSetting-000358": "预览前请先保存数据"
                            overlay={langCheck("ZoneSetting-000358", "pages", json)}
                        >
                            <NCButton
                                fieldid='preview'
                                onClick={() => {
                                    this.setPreviewModalVisibel(true);
                                }}>
                                {langCheck("ZoneSetting-000039", "pages", json)}
                                {/* /* 国际化处理： 预览*/}
                            </NCButton>
                        </NCTooltip>
                        {/* <NCButton> */}
                        {/* {langCheck('ZoneSetting-000006', 'pages', json)} */}
                        {/* /* 国际化处理： 取消*/}
                        {/* </NCButton> */}
                    </div>
                    <HotKeysModal
                        mask={true}
                        closable={false}
                        title={langCheck("ZoneSetting-000207", "pages", json)} /* 国际化处理： 提示消息*/
                        visible={this.state.backModalShow}
                        maskClosable={false}
                        size='sm'
                        className={"prompt-box-project"}
                        fieldid='back'
                        footer={[
                            <NCButton colors='primary' fieldid='save' onClick={this.handleSaveBack}>
                                {langCheck("ZoneSetting-000038", "pages", json)} {/* 国际化处理： 保存*/}
                            </NCButton>,
                            <NCButton fieldid='unsave' onClick={this.handleNotSaveBack}>
                                {langCheck("ZoneSetting-000206", "pages", json)} {/* 国际化处理： 不保存*/}
                            </NCButton>,
                            <NCButton fieldid='cancel' onClick={this.handleCancelBack}>
                                {langCheck("ZoneSetting-000006", "pages", json)} {/* 国际化处理： 取消*/}
                            </NCButton>,
                        ]}>
                        <p className='prompt-title'>
                            <i className='icon iconfont icon-zhuyi1 warning' />
                            <span>{langCheck("ZoneSetting-000204", "pages", json)}</span> {/* 国际化处理：返回*/}
                        </p>
                        <p className='prompt-content'>{langCheck("ZoneSetting-000205", "pages", json)}</p>{" "}
                        {/* 国际化处理：确定保存模板配置？*/}
                    </HotKeysModal>
                </NCDiv>
                {previewVisibel && (
                    <PreviewModal
                        previewVisibel={previewVisibel}
                        setModalVisibel={this.setPreviewModalVisibel}
                        templetData={templetData}
                        requestUrl='/nccloud/platform/templet/previewtemplet.do'
                        requestData={this.getPreviewData()}
                    />
                )}
            </Fragment>
        );
    }
}
//本文件sonar扫描装饰器写法不能解析，为了让sonar扫描通过，改成这么写（别的文件使用装饰器写法就没扫出来，深井冰）
MyHeader = withVaryModal((varyId, component) => {
    component.setState({ varyId }, component.saveTemplate);
})(MyHeader);
export default connect(
    state => {
        let {
            areaList,
            newAreaList,
            zoneFormData,
            isSave,
            areaVisible,
            isImplement,
            serverData,
            areaHide,
            ismobile,
        } = state.zoneSettingData;
        let { zoneDatas } = state.zoneRegisterData;
        return {
            areaList,
            zoneFormData,
            zoneDatas,
            isSave,
            newAreaList,
            areaVisible,
            isImplement,
            serverData,
            areaHide,
            ismobile,
        };
    },
    {
        setZoneData,
        updateAreaList,
        updateSaveFlag,
        setZoneDataFun,
        updateAreaValidate,
        setAreaItemVisible,
        setServerData,
        setAreaHide,
        setTabLayModalVisible,
        updateSelectArea,
        updateSelectCard,
    },
)(withRouter(MyHeader));
